import ChartContainer from '../../../Common/Services/charts/apex-charts/ChartContainer';
import useAnnualPercentageServices from './hooks/useAnnualPercentageServices';

export const AnnualPercentageServices = () => {
    const { chartConfig } = useAnnualPercentageServices();

    return (
        <ChartContainer
            title={'Total de Atendimentos'}
            options={chartConfig.options}
            series={chartConfig.series}
            type="bar"
            height={450}
        />
    );
};
